import axios from 'axios';

export function getCalendar({ companies, artisticFields, departments, audience, year }, options = undefined) {
   return axios.post('/agenda/recherche', {
       companies, artisticFields, departments, audience, year,
    }, options).then(response => response.data)
}

export function getCompanies({ query, ids }) {
    return axios.get('/autocomplete/companies', {
        params: {
            q: query,
            ids,
        },
    }).then(response => response.data.data);
}

export function getShow(id) {
    return axios.get(`/agenda/spectacle/${id}`)
        .then(response => response.data.data);
}